import React, { FC, useState } from "react";
import { Button } from "primereact/button";
import { AdmissionsSection } from "../../../../models/manageWebSite";
import EditModal from "./EditModal";

interface Props {
  data: AdmissionsSection | null;
  flag: boolean;
  setFlag: (flag: boolean) => void;
  homeId: string | null;
}

const Section12: FC<Props> = ({ data, flag, setFlag, homeId }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div style={{ width: "100%", background: "linear-gradient(180deg, #fffaf3 0%, #f8fafc 100%)", padding: "3rem 1.25rem" }}>
      <div style={{ maxWidth: "1180px", margin: "0 auto" }}>
        <div className="flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
          <div>
            <div style={{ color: "#b45309", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", fontSize: "0.8rem" }}>Optional Page</div>
            <div style={{ color: "#0f172a", fontSize: "2rem", fontWeight: 800, marginTop: "0.65rem" }}>FAQs</div>
            <div style={{ color: "#64748b", marginTop: "0.65rem", lineHeight: 1.7, maxWidth: "760px" }}>
              Add a page answering the most common questions families ask before choosing your home and planning a move-in.
            </div>
          </div>
          <Button label="Edit FAQ Page" severity="warning" className="website-section-action-button" onClick={() => setOpenModal(true)} />
        </div>
        <div className="grid">
          <div className="col-12">
            <div style={{ background: "#ffffff", border: "1px solid #f0dcc2", borderRadius: "24px", padding: "1.2rem", height: "100%", boxShadow: "0 16px 32px rgba(180,83,9,0.06)" }}>
              <div style={{ color: "#b45309", fontWeight: 800, textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "0.1em" }}>Frequently Asked Questions</div>
              <div className="grid mt-3">
                {(data?.faqs || []).map((item, index) => (
                  <div className="col-12 md:col-6" key={`${item.question}-${index}`}>
                    <div style={{ background: "#fffaf3", border: "1px solid #f0dcc2", borderRadius: "18px", padding: "1rem", height: "100%" }}>
                      <div style={{ color: "#92400e", fontWeight: 800, lineHeight: 1.5 }}>Q. {item.question}</div>
                      <div style={{ color: "#475569", lineHeight: 1.8, marginTop: "0.6rem" }}>A. {item.answer}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <EditModal isOpen={openModal} toggleModal={setOpenModal} flag={flag} setFlag={setFlag} data={data} homeId={homeId} />
    </div>
  );
};

export default Section12;
